module.exports = __webpack_public_path__ + "static/img/wealth_level_89.45bc25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_89.png
// module id = 8ugC
// module chunks = 0